import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { trackEvent } from '@xingternal/hops-tracking';
import { IconFilter } from '@xingternal/icons';

import { getFiltersFromAggregations } from '@/domain/search/helpers';
import { useSearch } from '@/domain/search/hooks';

import { FilterSalary } from './filter-salary';
import { FilterSet } from './filter-set';
import { useAreChildrenInline } from './hooks/use-are-children-inline';

import * as S from './filter-list.styles';

export const FilterList: React.FC = () => {
  const { loading, data, previousData } = useSearch();
  const { areInline, parentRef } = useAreChildrenInline();

  const [isCollapsed, setIsCollapsed] = useState(true);

  if (!loading && !data?.jobSearchByQuery?.aggregations) return null;

  const anyData = data ?? previousData;
  const filterList = getFiltersFromAggregations(anyData?.jobSearchByQuery?.aggregations ?? {});

  const toggleMoreFilters = (): void => {
    setIsCollapsed(!isCollapsed);
    trackEvent('PropTrackAction', { PropTrackAction: 'jobs_filter_more_click' });
  };

  return (
    <S.Container>
      <S.FiltersRow ref={parentRef} $isCollapsed={isCollapsed}>
        {filterList.map((filter, i) => {
          if (filter === 'salary') return <FilterSalary key={filter} />;

          if (typeof filter !== 'string') {
            return (
              <FilterSet
                options={filter.options}
                title={<FormattedMessage id={filter.titleKey} />}
                paramName={filter.paramName}
                key={`${filter.paramName}-${i}`}
              />
            );
          }
        })}
      </S.FiltersRow>
      {areInline ? null : (
        <S.TextButton icon={IconFilter} iconAfter onClick={toggleMoreFilters}>
          <FormattedMessage id={isCollapsed ? 'JOBS_SEARCH_MORE_FILTERS' : 'JOBS_SEARCH_LESS_FILTERS'} />
        </S.TextButton>
      )}
    </S.Container>
  );
};
